import {Component, computed, OnInit} from "@angular/core";
import {ActivatedRoute, Router} from "@angular/router";
import {Subscription} from "rxjs";
import {Location as RouterLocation} from '@angular/common';
import {PagesEventService, Url} from "src/app/common";
import {User, UserAuth} from "src/app/common/user-auth";
import {TicketNote} from "../models/notes.model";
import {TicketReply} from "../models/ticket-reply.model";
import {Ticket} from "../models/ticket.model";
import {TicketService} from "../services/ticket.service";
import {TranslateService} from "@ngx-translate/core";
import {translateCollection} from "src/app/common/utilities";
import {StatusService} from '../../../../../common/jira/services/status.service';
import {ChipThemeColor} from '@progress/kendo-angular-buttons';

@Component({
  selector: 'app-ticket-index',
  templateUrl: '../views/ticket.component.html',
  styleUrls: ['../styles/style.css']
})
export class TicketComponent implements OnInit {
  userAuth: User = UserAuth.get();
  isAdmin = UserAuth.isBoss(this.userAuth);
  url = Url;
  jiraStatus: string = "";
  newReply = new TicketReply();
  ticketNote = new TicketNote();
  ticket: Ticket = new Ticket();
  statusTypes = [];
  artArray = [];
  ticketReplies = [];
  allGroupTypes = [];
  groupTypes = [];
  subcategoryTypes = [];
  users_of_group = [];
  ticketHistoryData = [];
  statusType = null;
  idOfTicket = null;
  lastReplier = null;
  opened_file = null;
  photoView = null;
  photoReplyView = null;
  onSubmit = false;
  displayLastReplier = false;
  addNote = false;
  historySection = false;
  isUserInGroup = false;
  isAuthor=false;
  showInfoLogs = false;
  historyPhotoOpen = false;
  replyPhotoOpen = false;
  addNoteSection = true;
  ticketHistoryNumber = 0;
  isTicketSyncModalOpen = false;

  imageEditor = {
    show: false,
    top: 20,
    file: null,
    fileName: null,
    readUrl: null,
    saveUrl: null,
    width: window.innerWidth - 100,
    height: window.innerHeight,
    description: null,
  };

  imageEditorReply = {
    show: false,
    top: 20,
    file: null,
    fileName: null,
    readUrl: null,
    saveUrl: null,
    width: window.innerWidth - 100,
    height: window.innerHeight,
    description: null,
  };

  private routeSub: Subscription;
  constructor(private pagesEventService: PagesEventService,
              public ticketService: TicketService,
              private router: Router,
              private translateService: TranslateService,
              private routerLocation: RouterLocation,
              private route: ActivatedRoute,
              private statusService: StatusService,
) {
  }

  ngOnInit(): void {
    translateCollection(this)
    const lang = this.translateService.currentLang || 'de';
    this.ticketService.getStatusTypes(lang).subscribe(response => {
      this.statusTypes = response.StatusTypes;
    });
    this.ticketService.getArtTypes(lang).subscribe(response => {
      this.artArray = response.ArtTypes;
    });
    this.routeSub = this.route.params.subscribe(params => {
      const id = params['id'];
      this.newReply.ticket_id = id;
      this.getTicket(id);
      this.getReplies(id);
      this.idOfTicket = params['id'];
    });
  }

  onJiraIssueCreated() {
      this.isTicketSyncModalOpen = false;
  }

  jiraSyncContext = computed(() => ({
    ticket: this.ticket,
    ticketReplies: this.ticketReplies,
    fileUrl: this.url.ticketFileUrl
  }));

  goBack() {
    this.routerLocation.back();
  }

  getAllTicketsCategory() {
    this.ticketService.getAllTicketsCategory({type: this.ticket.type}).subscribe((response) => {
      response.TicketsCategory.forEach(category => {
        category.name = category.name ? this.translateService.instant(category.name) : ''
      })
      this.allGroupTypes = response.TicketsCategory;
      this.groupTypes = this.allGroupTypes.filter(ticket => ticket.type === this.ticket.type).sort((a, b) => a.name.localeCompare(b.name));
      this.subcategoryTypes = this.allGroupTypes.find(item => item.name === this.ticket.ticket_category)?.subcategory || [];
      this.subcategoryTypes.sort((a, b) => a.name.localeCompare(b.name));
    });
  }

  getReplies(id) {
    this.ticketService.getReplies(id).subscribe((response) => {
      if (response.Tickets.length !== 0) {
        this.displayLastReplier = true;
        this.lastReplier = response.Tickets[response.Tickets.length - 1];
      }
      response.Tickets.reduce((list, item) => {
        list.push(TicketReply.init(item));
        return list;
      }, []);
      this.ticketReplies = response.Tickets;
    });
  }

  getTicket(id) {
    this.ticketService.get(id).subscribe((response) => {
      if(response.Status == 200 && response.Ticket) {
        this.ticket = Ticket.init(response.Ticket);
        this.isAuthor= this.ticket.user_id == this.userAuth.id;
        this.getTicketsGroup();
        this.getAllTicketsCategory();
        if (this.ticket.jira_status_id) {
          this.loadJiraStatusColor(this.ticket.jira_status_id);
        }
      }
      else {
        this.router.navigate(['/ticket']);
      }
    });
  }

  artChanged() {
    this.ticketService.changeArt(Ticket.prepare(this.ticket)).subscribe((response) => {});
  }

  statusChanged() {
    this.ticketService.changeStatus(Ticket.prepare(this.ticket)).subscribe((response) => {});
  }

  groupChanged() {
    this.ticket.ticket_subcategory = null;
    this.ticket.ticket_subcategory_id = null;
    this.ticketService.changeCategory(Ticket.prepare(this.ticket)).subscribe((response) => {
      this.getTicket(this.ticket.id);
      this.subcategoryChanged();
    });
  }

  subcategoryChanged() {
    this.ticketService.changeSubcategory(Ticket.prepare(this.ticket)).subscribe((response) => {});
  }

  assignToUser() {
    this.ticket.assigned_user_name = this.ticket.assigned_user_id.fullName;
    this.ticketService.changeAssignedUser(Ticket.prepare(this.ticket)).subscribe((response) => {});
  }

  changeStatus() {
    if (this.ticket.status?.id == "New") {
      this.ticket.status = {id: 'Processing'};
      this.statusChanged();
    }
  }

  submit(value) {
    this.onSubmit=true;
    this.changeStatus();
    this.ticketService.createTicketReply(TicketReply.prepare(this.newReply)).subscribe((response) => {
      this.router.navigate(['/ticket']);
      this.onSubmit=false;
    });
  }

  onFilesAdded(event) {
    event.addedFiles.forEach(file => {
      this.ticketService.saveFile(file).subscribe((response) => {
        this.newReply.files = this.newReply.files || [];
        this.openEditorReply(file, response.File.fileName);
      });
    });
  }

  getTicketsGroup() {
    this.ticketService.getTicketsCategoryUsers(this.ticket.ticket_category_id?.id).subscribe((response) => {
      if(response.TicketsGroup.length > 0) {
        this.isUserInGroup = !!response.TicketsGroup[0].users.find(user => user.user_id == this.userAuth.id) || this.isAdmin;
        this.users_of_group = response.TicketsGroup[0].users.map(user => ({id:user.user_id,fullName:user.fullName}));
        if(this.ticket.assigned_user_id) {
          this.ticket.assigned_user_id= this.users_of_group.find(user => user.id == this.ticket.assigned_user_id?.id);
        }
      }
    });
  }

  addNoteClicked() {
    this.addNote = true;
    this.ticketNote.user_id = this.userAuth.id;
    this.ticketNote.ticket_id = this.idOfTicket;
    this.ticketService.getNumberHistoryTicketNote({ticket_id: this.idOfTicket}).subscribe((response) => {
      this.ticketHistoryNumber = response.Ticket;
    });
  }

  addNoteClosed() {
    this.addNote = false;
    this.addNoteSection = true;
    this.historySection = false;
  }

  submitNewNote() {
    this.ticketService.createTicketNote(this.ticketNote).subscribe((response) => {
      this.addNote = false;
      this.ticketNote = new TicketNote();
    });
  }

  addNoteSectionClicked() {
    this.addNoteSection = true;
    this.historySection = false;
  }

  historySectionClicked() {
    this.addNoteSection = false;
    this.historySection = true;
    this.ticketService.getHistoryTicketNote({ticket_id: this.idOfTicket}).subscribe((response) => {
      this.ticketHistoryData = response.Ticket;
    });
  }

  noteFileOne(event) {
    let file = event.addedFiles[0];
    this.ticketService.saveFile(file).subscribe((response) => {
      this.ticketNote.file_one_original_name = response.File.originalName;
      this.ticketNote.file_one_modified_name = response.File.fileName;
      this.openEditor(response.File, response.File.fileName, 'File_one');
    });
  }

  noteFileTwo(event) {
    let file = event.addedFiles[0];
    this.ticketService.saveFile(file).subscribe((response) => {
      this.ticketNote.file_two_original_name = response.File.originalName;
      this.ticketNote.file_two_modified_name = response.File.fileName;
      this.openEditor(response.File, response.File.fileName, 'File_two');
    });
  }

  openEditor(file, fileName, file_type) {
    this.imageEditor.file = file;
    this.imageEditor.description = file.description;
    this.imageEditor.fileName = fileName;
    this.imageEditor.readUrl = `/image/${fileName}`;
    this.imageEditor.saveUrl = `/tickets/files`;
    this.imageEditor.show = true;
    this.addNote = false;
    this.opened_file = file_type;
  }

  onEditorClosed(event) {
    if(event.file !== null) {
      if(this.opened_file == 'File_one') { this.ticketNote.file_one_modified_name = event.file.fileName; }
      if(this.opened_file == 'File_two') { this.ticketNote.file_two_modified_name = event.file.fileName; }
    }
    this.addNote = true;
    this.imageEditor.show=false;
    this.opened_file = null;
  }

  openEditorReply(file, fileName) {
    this.imageEditorReply.file = file;
    this.imageEditorReply.description = file.description;
    this.imageEditorReply.fileName = fileName;
    this.imageEditorReply.readUrl = `/image/${fileName}`;
    this.imageEditorReply.saveUrl = `/tickets/files`;
    this.imageEditorReply.show = true;
    this.addNote = false;
  }

  onEditorReplyClosed(event) {
    if(event.file !== null) {
      this.newReply.files.push(event.file);
    }
    this.imageEditorReply.show=false;
  }

  openHistoryPhoto(url) {
    this.historyPhotoOpen = true;
    this.photoView = `${this.url.ticketFileUrl}/${url}`;
    this.addNote = false;
  }

  closeHistoryPhoto() {
    this.historyPhotoOpen = false;
    this.photoView = null;
    this.addNote = true;
  }

  openReplyPhoto(url) {
    if(url.includes('.pdf')) {
      window.open(`${this.url.ticketFileUrl}/${url}`, '_blank');
    }
    else {
      this.replyPhotoOpen = true;
      this.photoReplyView = `${this.url.ticketFileUrl}/${url}`;
    }
  }

  closeReplyPhoto() {
    this.replyPhotoOpen = false;
    this.photoReplyView = null;
  }

  deleteFile(file) {
    this.newReply.files.splice(this.newReply.files.indexOf(file),1);
  }

  toggleTicketSyncModal() {
    if (this.isUserInGroup) this.isTicketSyncModalOpen = !this.isTicketSyncModalOpen;
  }

  jiraChipColor = computed(() => {
    const map: Record<string, ChipThemeColor> = {
      'blue-grey': 'base',
      'yellow': 'warning',
      'green': 'success',
    };
    return map[this.jiraStatus] ?? 'base';
  });


  private loadJiraStatusColor(id: string) {
    this.statusService.getStatus(id).subscribe(res => {
      this.jiraStatus = res.data.statusCategory.colorName;
    });
  }
}
